import { PlanoSaude } from "../plano-saude/plano-saude";
import { Medico } from "./medico";
import { MedicoPlanoSaudePk } from "./pks/medico-plano-saude-pk";

export class MedicoPlanoSaude {

    pk: MedicoPlanoSaudePk = new MedicoPlanoSaudePk();

    medico: Medico = new Medico();

    planoSaude: PlanoSaude = new PlanoSaude();

    constructor() {
    }
}
